module.exports = __webpack_public_path__ + "img/NegeriSembilan.13573e36.png";